import React from "react";
import Pagination from 'react-bootstrap/Pagination';

function Paginacao(props){
    const dados = props.dados    
    const page_numb = props.page_numb
    const loading = props.loading
    const limit = props.limit

    if(!dados || dados.count <= 0){
        return (
            <></>
        )
    }

    const onClickPagina = (num_page) => {           
        props._onClickPagina(num_page)
    };

    const reg_por_pag = (limit) ? limit : 30
    const num_pages = Math.ceil(dados.count / reg_por_pag)
    const pages_exibicao = 4

    let startPage = (page_numb < (pages_exibicao -1)) ? 1 : page_numb - (pages_exibicao / 2);
    let endPage = pages_exibicao + startPage;
    endPage = (num_pages < endPage) ? num_pages : endPage;
    const diff = startPage - endPage + pages_exibicao;
    startPage -= (startPage - diff > 0) ? diff : 0;

    let items = [];

    for (let i = startPage; i <= endPage; i++) {        
        if(page_numb === i){
            items.push(
                <Pagination.Item key={i} active>
                    {i}
                </Pagination.Item>,
            );
        }
        else {
            items.push(
                <Pagination.Item key={i} onClick={() => onClickPagina(i)} disabled={loading}>
                    {i}
                </Pagination.Item>,
            );
        }     
    }

    const inicio = (page_numb - 1) * reg_por_pag + 1;
    const fim = Math.min(page_numb * reg_por_pag, dados.count);
    
    return (
        <div className="d-flex justify-content-between align-items-center">
            {/* Texto de exibição de resultados à esquerda */}
            {inicio && fim ? (
                <div className="text-muted small">
                    Exibindo <strong>{inicio}</strong> a <strong>{fim}</strong> de <strong>{dados.count}</strong> resultados
                </div>
            ) : (
                <div className="text-muted small">
                    Exibindo <strong>{dados.count}</strong> resultados
                </div>
            )}
            
            
            {/* Paginação à direita */}
            <Pagination className="small-pagination mb-0">
                { dados.previous && <Pagination.Item onClick={() => onClickPagina(page_numb - 1)} disabled={loading}>Anterior</Pagination.Item> }            

                {items}
                
                { dados.next && <Pagination.Item onClick={() => onClickPagina(page_numb + 1)} disabled={loading}>Próxima</Pagination.Item> }            
            </Pagination>
        </div>
    );
}

export default Paginacao;